import { render, staticRenderFns } from "./PermissionsRequests.vue?vue&type=template&id=69248904&scoped=true"
import script from "./PermissionsRequests.vue?vue&type=script&lang=js"
export * from "./PermissionsRequests.vue?vue&type=script&lang=js"
import style0 from "./PermissionsRequests.vue?vue&type=style&index=0&id=69248904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69248904",
  null
  
)

export default component.exports